<template>
    <div id="contact" class="contact">
        <div class="contact__mask"></div>
        <div class="contact__content wrapper">
            <h2 class="title">Reach out to us</h2>
            <p></p>
            <div class="contact__content__form">
                <form class="contact__content__form__inputs">
                    <input v-model="form.name" type="text" placeholder="Name">
                    <input v-model="form.email" type="email" placeholder="Email">
                    <textarea v-model="form.message" placeholder="Message" rows="12"></textarea>
                </form>
                <button @click="sendMessage()" anim="ripple" :class="{bigger: isSuccess}" >
                    <span v-if="!isWorking && !isSuccess">SEND</span>
                    <vk-spinner v-if="isWorking && !isSuccess"></vk-spinner>    
                    <span v-if="isSuccess">Message sent!</span>
                </button>
            </div>
            <p class="contact__content__warning" :class="{warningVisible: isWarning}">Please fill all fields before sending message.</p>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

    export default {
        name: 'contact',

        data() {
            return {
                form: {
                    name: '',
                    email: '',
                    message: ''
                },
                isWorking: false,
                isWarning: false,
                isSuccess: false
            }
        },

        mounted() {
            this.ripple();
        },

        methods: {
            ripple() {
                [].map.call(document.querySelectorAll('[anim="ripple"]'), el=> {
                    el.addEventListener('click',e => {
                        e = e.touches ? e.touches[0] : e;
                        const r = el.getBoundingClientRect(), d = Math.sqrt(Math.pow(r.width,2)+Math.pow(r.height,2)) * 2;
                        el.style.cssText = `--s: 0; --o: 1;`;  el.offsetTop; 
                        el.style.cssText = `--t: 1; --o: 0; --d: ${d}; --x:${e.clientX - r.left}; --y:${e.clientY - r.top};`
                    })
                })
            },

            sendMessage() {
                if(this.form.name && this.form.email && this.form.message) {

                    this.isWorking = true;
                    if(this.isWarning === true) {this.isWarning = !this.isWarning;};
                    if(this.isSuccess === true) {this.isSuccess = !this.isSuccess;};

                    axios.post( '/send-message', this.form)
                        .then(res => {
                            this.isSuccess = true;
                            this.isWorking = false;
                        })
                        .catch(err => {
                            this.isWorking = false,
                            alert('We are sorry but we couldn\'t send your message.')
                            console.error(err)
                        })

                } else {
                    this.isWarning = true;
                }
            }
        },
    }; 
</script>


<style lang="scss" scoped>
    .contact {
        width: 100%;
        background-image: url("../assets/contact.jpg");
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        background-attachment: fixed;
        position: relative; 


        &__mask {
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.4);
        }

        .wrapper {
            padding: 180px 0;
        }

        &__content {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;



            h2 {
                color: white;
                font-size: 4em;
                margin-bottom: 0px;
            }

            p {
                color: white;
                text-align: center;
            }

            &__form {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 20px 0;

                &__inputs {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    max-width: 420px;

                    input,
                    textarea {
                        background: rgba(255, 255, 255, 0.35);
                        border: 1px solid transparent;
                        border-radius: 5px;
                        margin: 5px 0;
                        color: white;
                        font-size: 1.2rem;
                        line-height: 1.8rem;
                        padding: 0.9rem;
                        resize: none;

                        &::placeholder {
                            color: white;
                            font-weight: bold;
                        }

                        &:focus {
                            border-radius: 5px;
                            border: 1px solid #ff5400;
                            outline: none;
                            background: rgba(128, 128, 128, 0.6);
                            transition: ease-in-out .4s;
                        }
                    }
                }

                button {
                    min-height: 50px;
                    width: 150px;
                    align-self: flex-end;
                    margin: 0 0 5px 30px;
                    font-size: 1.1rem;
                    font-weight: bold;
                    color: white;
                    background-color: #ff5400;
                    border: 0;
                    border-radius: 25px;
                    cursor: pointer;
                    outline: none;
                    letter-spacing: 1px;
                    transition: ease-in-out .2s;


                    --ripple-background: white;
                    --ripple-opacity: 0.3;  
                    --ripple-duration: 600ms;

                    span {
                        padding: 15px 0;
                        display: block;
                    }
                }

                .bigger {
                    width: 180px;
                }
            }

            &__warning {
                margin: -10px 0 0 0;
                font-size: 16px;
                color: white;
                font-weight: bold;
                text-decoration: underline;
                text-decoration-color: red;
                opacity: 0;
                transition: ease-in-out .4s;
            }
            .warningVisible {
                opacity: 1;
            }
        }
    }

    [anim="ripple"] {
        position: relative;
        overflow: hidden;

        &:before {
            content: '';
            position:absolute;
            display: block;
            background: var(--ripple-background, white);      
            border-radius: 50%;
            pointer-events: none; 
            
            //  position and size 
            top: calc(var(--y) * 1px);
            left: calc(var(--x) * 1px);
            width:  calc(var(--d) * 1px);
            height: calc(var(--d) * 1px);

            //  animated properties
            opacity: calc(var(--o, 1) * var(--ripple-opacity, 0.3));                
            transition: calc(var(--t, 0) * var(--ripple-duration, 600ms)) var(--ripple-easing,linear);   
            transform: translate(-50%, -50%) scale(var(--s, 1));
            transform-origin: center;
        }
    }

	@media all and (max-width: 970px) {
		.contact .wrapper {
            padding: 150px 0;
        }
    }

	@media all and (max-width: 830px) {
		.contact__content  {
            h2 {
                font-size: 3em;
            }

            &__form {
                padding: 0 40px;

                &__inputs {
                    input,
                    textarea {
                        font-size: 1.2rem;
                        line-height: 1.5rem;
                        padding: 0.7rem;
                    }
                }

                button {
                    width: 120px;
                }
            }
        }
    }

	@media all and (max-width: 530px) {
		.contact {
            .wrapper {
                padding: 90px 0;
            }

            &__content  {
                h2 {
                    font-size: 2em;
                }   


                &__form {
                    flex-direction: column;
                    &__inputs {
                        input,
                        textarea {
                            font-size: 1.1rem;
                            line-height: 1.4rem;
                            padding: 0.6rem;
                        }
                    }

                    button {
                        width: 150px;
                        align-self: initial;
                        margin-top: 20px;
                        margin-left: 0;
                    }
                }
            }
        }
    }

</style>

<style scoped>

    @media not all and (min-resolution:.001dpcm) { @media
    {
        .contact {
            background-attachment:initial;
        }
    }}

</style>